import postCard from '../modules/post-card';
import carousel from '../modules/carousel';
export default {
    init() {},
    finalize() {
        postCard();
        carousel();
    },
};
